import { type CustomResolversContext } from '../types';

const deleteUserAvatar = async (
	_: any,
	args: { userId: string },
	context: CustomResolversContext,
) => {
	const { userId } = args;
	const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
	return context.fetch(url, { method: 'DELETE' }).then(() => true);
};

export default deleteUserAvatar;
